// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3NNdq","vLegacy":"SelectSecondary_vLegacy__2o7tK","error":"SelectSecondary_error__1BD0K","disabled":"SelectSecondary_disabled__8Zexq"};